import { sbEditable } from '@storyblok/storyblok-editable';
import React, { FC } from 'react';

type CodeBlockComponentProps = {
  CodeBlock: string;
  _uid: string;
  _editable?: string;
  component: string;
};

const CodeBlockComponent: FC<
  React.PropsWithChildren<CodeBlockComponentProps>
> = (props) => {
  const { CodeBlock } = props;

  return (
    <div {...sbEditable(props)}>
      {CodeBlock && <div dangerouslySetInnerHTML={{ __html: CodeBlock }} />}
    </div>
  );
};

export default CodeBlockComponent;
